


export default function stringArgReplace(str,...arg){
    for(var i=0; i<arg.length ; i++){
        str = str.replace(`%${i+1}`,arg[i])
    }
    return str
}